var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "21px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(102, 102, 102)",
    d: "M0.0,20.999 L0.0,5.999 L0.0,0.0 L19.999,0.0 L19.999,5.999 L19.999,20.999 L0.0,20.999 ZM6.999,1.999 L4.999,1.999 L4.999,3.999 L6.999,3.999 L6.999,1.999 ZM14.999,1.999 L12.999,1.999 L12.999,3.999 L14.999,3.999 L14.999,1.999 ZM18.999,5.999 L0.999,5.999 L0.999,19.999 L18.999,19.999 L18.999,5.999 ZM4.999,13.999 L2.999,13.999 L2.999,11.999 L4.999,11.999 L4.999,13.999 ZM4.999,17.999 L2.999,17.999 L2.999,15.999 L4.999,15.999 L4.999,17.999 ZM8.999,9.999 L6.999,9.999 L6.999,7.999 L8.999,7.999 L8.999,9.999 ZM8.999,13.999 L6.999,13.999 L6.999,11.999 L8.999,11.999 L8.999,13.999 ZM8.999,17.999 L6.999,17.999 L6.999,15.999 L8.999,15.999 L8.999,17.999 ZM12.999,9.999 L10.999,9.999 L10.999,7.999 L12.999,7.999 L12.999,9.999 ZM12.999,13.999 L10.999,13.999 L10.999,11.999 L12.999,11.999 L12.999,13.999 ZM12.999,17.999 L10.999,17.999 L10.999,15.999 L12.999,15.999 L12.999,17.999 ZM16.999,9.999 L14.999,9.999 L14.999,7.999 L16.999,7.999 L16.999,9.999 ZM16.999,13.999 L14.999,13.999 L14.999,11.999 L16.999,11.999 L16.999,13.999 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCal);
export default __webpack_public_path__ + "static/media/ico_cal.caff68383c5017d2d8bcccfc1f5527a7.svg";
export { ForwardRef as ReactComponent };